import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-search\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.5 2.25a9.25 9.25 0 000 18.5 9.213 9.213 0 005.989-2.2l2.98 2.98 1.061-1.06-2.98-2.981a9.213 9.213 0 002.2-5.989 9.25 9.25 0 00-9.25-9.25zM3.75 11.5a7.75 7.75 0 1115.5 0 7.75 7.75 0 01-15.5 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol